import { render, staticRenderFns } from "./youyougu.vue?vue&type=template&id=3e311c6d&scoped=true"
import script from "./youyougu.vue?vue&type=script&lang=js"
export * from "./youyougu.vue?vue&type=script&lang=js"
import style0 from "./youyougu.vue?vue&type=style&index=0&id=3e311c6d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e311c6d",
  null
  
)

export default component.exports